import React, { PropsWithChildren } from 'react'

const index = ({ children }: PropsWithChildren) => {
    return (
        <div>{children}</div>
    )
}

export default index